export const whyChooseUsContent = {
  title: "Why Contractors Choose Us",
  subtitle: "Our advantage",
  sections: [
    {
      icon: "PrecisionManufacturingIcon",
      heading: "We Improve Accuracy",
      body: "You can't grow a business on guesswork. Our process dials in your numbers to **pinpoint accuracy** so every cost is tracked, bids are competitive, and no dollars are left unaccounted for.",
      iconColor: "#F9A825",
      highlightColor: "#FFCA28",
      iconBg: "#3E2F00",
    },
    {
      icon: "EmojiEventsIcon",
      heading: "We Help You Win More Bids",
      body: "We’re bidding 4–6 projects per month for clients, with a **10% - 30% average win rate**. As we learn your market and improve your data, your **bids get sharper, more competitive**, and more trusted by GCs & Clients.",
      iconColor: "#F9A825",
      highlightColor: "#FFCA28",
      iconBg: "#3E2F00",
    },
    {
      icon: "TrendingUpIcon",
      heading: "We Give You Predictable Growth",
      body: "A **steady flow of work** brings peace of mind. Our system helps keep your pipeline full so you’re not scrambling between jobs or stressing about cash flow.",
      iconColor: "#F9A825",
      highlightColor: "#FFCA28",
      iconBg: "#3E2F00",
    },
    {
      icon: "MoreTimeIcon",
      heading: "We Free Up Your Time",
      body: "When your estimating systems run smoothly, you **get your time back**. With Hungerford handling the heavy lifting, contractors reclaim hours every week to focus on operations, growth, or simply take a breath.",
      iconColor: "#F9A825",
      highlightColor: "#FFCA28",
      iconBg: "#3E2F00",
    },
  ],
};
